// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
// import React, { FC } from "react"; // Greif Custom Code

/* Greif Custom Code - Start */
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import React, { FC, useEffect, useState } from "react";
/* Greif Custom Code - End */

const OrderCancelNotification = getWidgetComponent("OrderDetails/OrderCancelNotification");

export interface OrderDetailsHeaderProps extends WidgetProps {}

export interface OrderDetailsHeaderStyles {}

export const orderDetailsHeaderStyles: OrderDetailsHeaderStyles = {};

const styles = orderDetailsHeaderStyles;

const OrderDetailsHeader: FC<OrderDetailsHeaderProps> = ({ id }) => {
    const currentPage = useCurrentPage();
    const linkBack = usePageLinkByPageType(constants.pageType.orderHistory);
    /* Greif Custom Code - Start */
    const orderSearchFilters = useAppSelector(state => state.pages.orderHistory.getOrdersParameter);
    const [queryParams, setQueryParams] = useState<string>("");

    useEffect(() => {
        if (orderSearchFilters) {
            const searchParams = new URLSearchParams();
            Object.keys(orderSearchFilters).forEach(key => searchParams.append(key, (orderSearchFilters as any)[key]));
            setQueryParams(searchParams.toString());
        }
    }, [orderSearchFilters]);

    const _linkBack = {
        ...linkBack,
        url: queryParams ? `${linkBack?.url}?${queryParams}` : linkBack?.url,
    } as PageLinkModel;
    /* Greif Custom Code - End */

    return (
        <OrderHeader
            title={currentPage.fields.title}
            linkBack={_linkBack} /* Greif */
            message={<OrderCancelNotification />}
        >
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsHeader,
    definition: {
        group: "Order Details",
        displayName: "Header",
        allowedContexts: ["OrderDetailsPage"],
    },
};

export default widgetModule;
